import { ITheme } from '@/lib/interfaces/interfaces'

interface Props{
  theme: ITheme
}

const Divider = ({ theme } : Props) => {
  return (
    <hr style={{ borderColor: theme.items.dividerColor }} className='divider' />
  )
}

export default Divider
